import React from 'react'
import { COLORES } from '../../../../config/colores'
import { connect } from 'react-redux'
import { Tooltip, Button } from '@material-ui/core'
import { submitPlanDeEmbarque } from '../../actions/PlanDeEmbarqueActions'

function OperacionesPlanDeEmbarque (props) {
  const { anuncio } = props

  const handleSubmit = () => { props.submitPlanDeEmbarque(anuncio) }

  const datosRequeridos = anuncio.agenciaMaritima && anuncio.nombreCorto

  return (
    <>
      {datosRequeridos
        ? <Tooltip title={'Crear plan de embarque'} >
          <Button
            variant='outlined'
            style={{ color: COLORES.grey.dark, width: '100%', fontWeight: 'bold' }}
            size='small'
            onClick={handleSubmit}
          >
              GENERAR
          </Button>
        </Tooltip>
        : null
      }
    </>
  )
}

const mapActionsToProps = {
  submitPlanDeEmbarque
}

const withRedux = connect(null, mapActionsToProps)

export default withRedux(OperacionesPlanDeEmbarque)
